<template>
    <svg aria-hidden="true" focusable="false" width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 11L2 11" stroke="black" stroke-width="1.5" />
        <path d="M11.5 1L2 11L11.5 21" stroke="black" stroke-width="1.5" />
    </svg>
</template>
